import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MainPagetitle from '../../layouts/MainPagetitle';
import AdminPdfprotocolService from '../../api/services/AdminPdfprotocolService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader'; 

const PdfprotocolAdd = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [file, setFile] = useState()
    const [isLoading, setisloading] = useState(false);
    const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
    const [error, setError] = useState([]);
    const [GetFilename, setFilename] = useState(true);

    useEffect(() => {
        if (localStorage.getItem("admintoken")) {

        }
        else {
            navigate('/')
        }
    }, []);

    const onFileChange = (e) => {
        const selectedFile = e.target.files[0];  
        const fileName = selectedFile.name.split('.').slice(0, -1).join('.');
        setFilename(fileName);
        
        if (selectedFile) {
            // Validate the file type
            const isPDF = selectedFile.type === 'application/pdf' || selectedFile.name.endsWith('.pdf');
            const fileSizeMB = selectedFile.size / (1024 * 1024); // Convert size to MB

            if (!isPDF) {
                setError("Please upload a valid PDF file.");
                // setIsSubmitEnabled(false);
                e.target.value = null;  
                return;  
            }

            if (fileSizeMB > 10) {
                setError("File size exceeds the maximum limit of 10MB.");
                // setIsSubmitEnabled(false);
                e.target.value = null;  
                return;  
            }

            // If validations pass, read file as Data URL
            const fileReader = new FileReader();

            fileReader.onload = () => {
                const base64String = fileReader.result.split(',')[1]; 
                setFile(base64String); 
                setError(""); 
                // setIsSubmitEnabled(true); 
            };

            fileReader.onerror = (error) => {
                console.error("FileReader error:", error);
                setError("Error reading file.");
                // setIsSubmitEnabled(false);
                e.target.value = null;  
            };

            fileReader.readAsDataURL(selectedFile);
        } else {
            setError("No file selected.");
            setFile(null); 
            e.target.value = null;  
            // setIsSubmitEnabled(false); 
        }
    };

    const onSubmitForm = async (event) => {
        event.preventDefault(); 
         
        setisloading(true);
        try {
            var pdfname = event.target.pdfname.value
            var userData = {
                "user_id": params.id,
                "pdfname":pdfname ? pdfname : GetFilename,
                "pdf": file,  
            } 
            if (!file) {
                setError("Pdf upload field is required.");
                setisloading(false);
                return;
            } 
            let responseData = await AdminPdfprotocolService.store(userData).json()
           
            if (responseData.status === true) { 
                navigate(`/admin/pdfprotocol/${params.id}`);
            }
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    };

    return (
        <>
            <MainPagetitle mainTitle="Add Pdf" pageTitle={'Add Pdf'} parentTitle={'Home'} />
            <div className="container-fluid">
                <form className="form-valide" onSubmit={onSubmitForm}>
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">Add Pdf</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row"> 
                                        <div className="col-xl-6 mb-3">
                                            <label htmlFor="val-number" className="form-label"> PDF Name  </label> 
                                            <input 
                                            type="text" 
                                            className="form-control" 
                                            name="pdfname"  
                                        />
                                        </div> 
                                        <div className="col-xl-6 mb-3">
                                            <label htmlFor="val-number" className="form-label"> PDF upload <span className="text-danger">*</span></label> 
                                            <input 
                                            type="file" 
                                            className="form-control" 
                                            name="pdf" 
                                            id="val-number" 
                                            accept=".pdf, application/pdf" 
                                            onChange={onFileChange} 
                                        />
                                        </div> 
                                    </div>
                                    <h5 style={{ color: 'red' }}>{error}</h5>
                                    <div>
                                        <button type="submit" className="btn btn-primary me-1" disabled={isSubmitEnabled}>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};
export default PdfprotocolAdd;